import React from "react";
import Checkbox from "components/Checkbox";
import { useRecoilState } from "recoil";
import {
  termsOfServiceState,
  termsOfServiceErrorState
} from "states/CheckOutStates/atoms";
import { colors } from "constants/colors";
import { TermsOfServiceContainer } from "./style";

const TermsOfServiceBlock: React.FC = () => {
  const [checked, setChecked] = useRecoilState(termsOfServiceState);
  const [error, setError] = useRecoilState(termsOfServiceErrorState);

  const toggle = () => {
    setChecked((prev) => {
      const value = !prev;
      localStorage.setItem("termsOfServiceChecked", value.toString());
      return value;
    });
    setError(false);
  };

  return (
    <TermsOfServiceContainer>
      <div className="termsOfService">
        <Checkbox
          checked={checked}
          error={error}
          borderColor={colors.signInBorderColor}
          onChange={toggle}
          checkboxScale={1.5}
          checkboxGreen={true}
        />

        <div className="text">
          <span className="plainText" onClick={toggle}>
            I agree to receive phone calls, text messages, and emails from Rook
            Hotel; Additionally I agree to Rook Hotel’s{" "}
          </span>

          <span
            className="highLight"
            onClick={() =>
              window.open("/terms-and-conditions", "_blank", "noopener,noreferrer")
            }
          >
            Terms of Service
          </span>
          {" "}and{" "}
          <span
            className="highLight"
            onClick={() =>
              window.open("/terms-and-conditions", "_blank", "noopener,noreferrer")
            }
          >
            Privacy Policy
          </span>
          <span className="required">*</span>
        </div>
      </div>

      {error && (
        <div className="required">
          Please accept the terms of service and try again.
        </div>
      )}
    </TermsOfServiceContainer>
  );
};

export default TermsOfServiceBlock;
